module.exports = {

    templateUrl: "/partials/components/PurchaseTemplate.tpl?" + __webpack_hash__,
    controller: require( "../controllers/PurchaseController" ),
    controllerAs: "purchaseCtrl"
}